module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_8.211e11a2.png";